module.exports = __webpack_public_path__ + "static/media/ste_2009_avezzano_1.1eaea9d5.jpg";